import { c as _c } from "react/compiler-runtime";
import React, { forwardRef } from 'react';
import { StyledMenuItem } from './styles';
import { type SelectItemProps } from './types';
export const SelectItem = forwardRef<HTMLLIElement, SelectItemProps>((t0, ref) => {
  const $ = _c(9);
  let children;
  let props;
  let selected;
  if ($[0] !== t0) {
    ({
      children,
      selected,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = selected;
  } else {
    children = $[1];
    props = $[2];
    selected = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== props || $[6] !== ref || $[7] !== selected) {
    t1 = <StyledMenuItem selected={selected} ref={ref} {...props}>{children}</StyledMenuItem>;
    $[4] = children;
    $[5] = props;
    $[6] = ref;
    $[7] = selected;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
});